import React from "react";

const RequiredAsterisk = () => <span style={{ color: "red" }}>*</span>;

export default RequiredAsterisk;
